import React, { useState } from 'react';
import rest from '../../data/restWrapper';
import UserRegistration from '../userRegistration';
import { initKeycloak } from '../../keycloak';
import translate from '@data/translations';
import { ReactComponent as LogoOnly } from '../../assets/custom/logo/logo_only.svg';

//@ts-ignore
import pubsub from '../../data/pubsub';
import useStore from '@data/state/zustand';
import { openInNewTab } from '@pages/helpAndInformations/helpAndSupport';

async function authenticate(email: string, password: string) {
    return await rest('/authenticateUser', 'POST', { email, password });
}

const getUrlParameterByName = (paramname: string, url?: string) => {
    if (!url) url = window.location.href;
    paramname = paramname.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + paramname + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const KeycloakLogin = () => {
    React.useEffect(() => {
        async function fetchData() {
            let timeoutId = setTimeout(() => {
                console.log('Keycloak init taking too long, reloading...');
                clearTimeout(timeoutId); // Clear timeout if Keycloak initializes successfully
                window.location.reload();
            }, 5000);

            try {
                await initKeycloak({ onLoad: 'login-required' });
                clearTimeout(timeoutId); // Clear timeout if Keycloak initializes successfully
            } catch (error) {
                console.error('Keycloak init failed:', error);
            }
        }
        fetchData();
    }, []);

    return <div>Redirecting...</div>;
};

interface LoginPageProps {
    showRegistration?: boolean;
    history: any;
}

function LoginPage(props: LoginPageProps) {
    const [posts, setPosts] = useState([]);
    const [registerUser, setRegisterUser] = useState(
        props.showRegistration !== undefined ? props.showRegistration : (false as boolean)
    );
    const [email, setEmail] = useState('' as string);
    const [password, setPassword] = useState('' as string);
    const [errorMessage, setErrorMessage] = useState('' as string);
    const [isKeycloakLoginActive, setIsKeycloakLoginActive] = useState(false as boolean);
    const [loginLoading, setloginLoading] = useState(false);
    const licence = useStore((appState) => appState.licence);
    const isPosOnPremIncluded = licence?.licence?.decodedLicence?.pack?.features?.includes('posOnPrem');


    const currentYear = new Date().getFullYear();


    React.useEffect(() => {
        const keyDownHandler = async (event: any) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                await submitForm();
            }
        };

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
        // eslint-disable-next-line
    }, [email, password]);

    React.useEffect(() => {
        const fetchRSSFeed = async () => {
            try {
                // Koristi URL RSS feed-a iz Next.js aplikacije
                const response = await fetch('https://hologic.io/api/generate-rss');
                if (response?.ok) {
                    const rssData = await response.json();
                    if (rssData?.rss?.channel?.item) {
                        let _posts =
                            rssData?.rss?.channel?.item?.length > 0
                                ? rssData?.rss?.channel?.item
                                : [rssData?.rss?.channel?.item];
                        _posts = _posts?.sort(function (a: any, b: any) {
                            const dateA: any = new Date(a.pubDate);
                            const dateB: any = new Date(b.pubDate);
                            return dateB - dateA;
                        });

                        if (process.env.NODE_ENV === 'production') {
                            const instanceNameObj = await rest('/getInstanceName');
                            let client = instanceNameObj?.instanceName ? instanceNameObj?.instanceName : null;
                            _posts = _posts
                                ?.filter((p: any) =>
                                    p?.tags?.tag?.length > 0 ? (p?.tags?.tag?.includes(client) ? p : null) : p
                                )
                                ?.filter((p: any) => p !== null);
                        }
                        setPosts(_posts);
                    }
                }
            } catch (error: any) {
                console.error('Error fetching or parsing RSS feed:', error.message);
            }
        };

        fetchRSSFeed().catch((err) => {
            console.warn(err);
        });
        // eslint-disable-next-line
    }, []);

    const submitForm = async (e?: any) => {
        try {
            if (e) {
                e.preventDefault();
            } //if comming from a form
        } catch (err) {}

        try {
            setloginLoading(true);
            const tokenInfo = await authenticate(email, password);
            const { user } = tokenInfo;
            if (user && (user.role === 'posBartender' || user.role === 'posKitchen')) {
                if (process.env.NODE_ENV === 'development') {
                    //@ts-ignore
                    window.location = `http://localhost:5000/#/?userUuidPos=${user?.uuid}`;
                } else {
                    //@ts-ignore

                    window.location = `${window.location.origin}/pos/#/?userUuidPos=${user?.uuid}`;
                }
            } else {
                useStore.getState().setNestedProperty(['authTokenInfo'], tokenInfo);
                //@ts-ignore
                pubsub.emit('loginSuccess', email);
            }
            setloginLoading(false);
        } catch (err: any) {
            setErrorMessage(err.message);
            setloginLoading(false);
        }
    };

    const showRegister = (e: any) => {
        e.preventDefault();
        setRegisterUser(true);
    };

    if (registerUser) {
        return (
            <UserRegistration
                onCancel={() => {
                    setRegisterUser(false);
                }}
            />
        );
    }

    if (isKeycloakLoginActive) {
        return <KeycloakLogin />;
    }

    const registerButton =
        getUrlParameterByName('showRegisterButton') === 'true' ? (
            <div onClick={showRegister} className="button-primary mt-8p">
                {translate('Register')}
            </div>
        ) : null;
    //registerButton = <button onClick={showRegister} className="button-primary ml-2">Register</button> //if you ever change your mind, just coment it

    return (
        <div className="login-wrapper">
            <div className="login-background">
                <CSSCarousel slides={posts} />

                <div className="login-logo">
                    <div className="logo"></div>
                </div>
            </div>
            <div className="login-form-wrapper">
                <div className="login-bg-white" style={{ height: registerButton ? '570px' : '550px' }}>
                    <div className="form-wrapper">
                        <div
                            className="form-container"
                            style={{ height: registerButton ? '570px' : isPosOnPremIncluded ? '440px' : '530px' }}
                        >
                            <div className="logo-only">
                                <LogoOnly />
                            </div>
                            <div className="mt-16p" style={{ fontSize: '20px', fontWeight: 800 }}>
                                {translate('Welcome back!')}
                            </div>
                            <p className="p-text">{translate('Please enter your details to log in.')}</p>
                            <br />
                            <div className="">
                                <label className="bold-letters">{translate('Email')}</label>
                                <div className="input-container mb-4p" style={{ width: '100%' }}>
                                    <input
                                        value={email}
                                        autoComplete="off"
                                        type="email"
                                        name="email"
                                        placeholder={translate('Email')}
                                        className="input-field "
                                        onChange={(e: any) => {
                                            let _email = e.target.value;
                                            setEmail(_email);
                                        }}
                                    />
                                </div>
                                <label className="bold-letters mt-16p">{translate('Password')}</label>
                                <div className="input-container mb-4p" style={{ width: '100%' }}>
                                    <input
                                        value={password}
                                        type="password"
                                        autoComplete="off"
                                        name="password"
                                        placeholder={translate('Password')}
                                        className="input-field"
                                        onChange={(e: any) => {
                                            let _password = e.target.value;
                                            setPassword(_password);
                                        }}
                                    />
                                </div>
                                {/* <div className="ml-8p mt-16p">
                                    <input
                                        checked={true}
                                        onChange={() => {}}
                                        className="checkbox-primary"
                                        type="checkbox"
                                    ></input>{' '}
                                    {translate('Remember me')}
                                </div> */}
                                <br />
                                <div className="button-primary " onClick={loginLoading ? () => {} : submitForm}>
                                    {loginLoading ? (
                                        <span className="text-center">
                                            <i className="fa fa-spinner fa-spin"></i>{' '}
                                            <span className="pl-2p">{translate("PLEASE WAIT")}</span>{' '}
                                        </span>
                                    ) : (
                                        translate('Log in')
                                    )}
                                </div>
                                {registerButton}
                                <br />
                                {isPosOnPremIncluded ? null : (
                                    <div>
                                        <div className="hr-span p-text"></div>
                                        <div
                                            className="button-secondary ml-auto mr-auto"
                                            style={{ width: '55%' }}
                                            onClick={() => {
                                                setIsKeycloakLoginActive(true);
                                            }}
                                        >
                                            {translate('Log in using IAM')}
                                        </div>
                                    </div>
                                )}
                                {errorMessage !== '' ? (
                                    <div className="alert-box mt-8p mb-8p" role="alert">
                                        {translate(errorMessage)}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="p-text-small mt-8p" style={{ textAlign: 'center' }}>
                        {translate('Having trouble logging in? Contact us at info@hologic.io')}
                    </div>
                </div>
                <div className="p-text-small copyright flex-center">
                    &copy; {` ${currentYear}`} {translate('Copyright')}{' '}
                    <div
                        className="ml-4p pointer"
                        onClick={() => {
                            openInNewTab('https://hologic.io/');
                        }}
                    >
                        <a href="https://hologic.io/" target="_blank" rel="noreferrer">
                            {' '}
                            HOLOGIC
                        </a>
                    </div>{' '}
                    {translate(' - All Rights Reserved')}
                </div>
            </div>
        </div>
    );
}

export default LoginPage;

export const CSSCarousel = ({ slides }: any) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Automatsko listanje svakih 3 sekunde
    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
    };

    React.useEffect(() => {
        const interval = setInterval(nextSlide, 10000); // 3 sekunde
        return () => clearInterval(interval); // Čišćenje intervala kada se komponenta unmounta
        // eslint-disable-next-line
    }, [slides?.length]);

    if (slides?.length === 0) {
        return null;
    }

    return (
        <div className="carousel-out-wrapper">
            {slides?.length > 1 ? (
                <button className="carousel-button prev" onClick={prevSlide}>
                    ❮
                </button>
            ) : null}
            <div className="carousel-container">
                <div className="carousel-wrapper">
                    <div className="carousel-slider" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                        {slides?.length > 0 ? (
                            slides.map((slide: any, index: number) => (
                                <div
                                    key={index}
                                    className="carousel-slide"
                                    onClick={() => {
                                        if (slide?.guid?._) {
                                            openInNewTab(slide?.guid?._);
                                        }
                                    }}
                                >
                                    <div className="blog-img">
                                        <img src={slide?.enclosure?.$?.url} alt="hologic-blog" />
                                        {/* <LogoOnly /> */}
                                    </div>
                                    <div className="blog-text-wrapper ml-4p">
                                        <div className="blog-title">{slide?.title}</div>
                                        <div className="blog-description">{slide?.description}</div>
                                        <div className="visit-website">{translate('VISIT WEBSITE')}</div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="carousel-slide"></div>
                        )}
                    </div>
                </div>
            </div>
            {slides?.length > 1 ? (
                <button className="carousel-button next" onClick={nextSlide}>
                    ❯
                </button>
            ) : null}
        </div>
    );
};
